<template>
  <geo-chart
    class="foo"
    :data="data"
    :library="options"
  ></geo-chart>

</template>

<script>

export default {
  name: 'ShipmentsByCountry',
  data () {
    return {
      data: [['France', 44], ['Germany', 53], ['Czech Republic', 22]],

      options: {
        region: '150',
        colorAxis: { colors: ['#ff616f', '#ff1744'] },
        datalessRegionColor: '#efefef',
        defaultColor: '#f5f5f5'
      }

    }
  }
}
</script>
